import axios from 'axios'
import { configureAxiosAuth, enforceLogoutIfExpired } from '../modules/auth/core/AuthHelpers'

configureAxiosAuth(axios)

export default axios

export function postDashboardForm(url, formData) {
  const token = localStorage.getItem('authTokenLoop')

  return axios({
    method: 'post',
    url,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + token,
    },
  }).then((response) => {
    if (enforceLogoutIfExpired(response)) {
      return Promise.reject(new Error('Session expired'))
    }

    return response
  })
}
